import React, { useEffect, useState } from "react";
import fire from "./Firebase";

import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import Adminheader from "../Adminheader";
function Viewcontact() {
  document.title = "HR School - View Contact";
  var [contactfirebase, setcontactfirebase] = useState({});
  const navigate = useNavigate();
  function logout() {
    toast.success("ID is Logout");
    setTimeout(() => {
      navigate("/");
    }, 200);
  }
  useEffect(() => {
    fire.child("contactdata").on("value", (all) => {
      if (all.val() == null || all.val() == "")
        toast.success("All Data is clear");
      else setcontactfirebase(all.val());
      //   setcontactfirebase(all.val());
    });
  }, []);
  function del(all) {
    fire.child(`contactdata/${all}`).remove((delt) => {
      if (delt) toast.error("sucess");
      else toast.success("Deleted");
    });
    console.log(all);
  }

  return (
    <div>
      <Adminheader/>
      <div className="container-fluid mimin-wrapper">
        {/* start:Left Menu */}
        <div id="left-menu">
          <div className="sub-left-menu scroll">
            <div className="wheather">
              {" "}
              <br />
              <br />
              <div
                className="stormy rainy animated pulse infinite"
                title="Hero"
              >
                <div className="shadow">Mr.H</div>
              </div>
              <div className="sub-wheather">
                <div className="thunder"></div>
                <div className="rain">
                  <div className="droplet droplet1" />
                  <div className="droplet droplet2" />
                  <div className="droplet droplet3" />
                  <div className="droplet droplet4" />
                  <div className="droplet droplet5" />
                  <div className="droplet droplet6" />
                </div>
              </div>
            </div>
            <ul className="nav nav-list">
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/profile">
                  DashBoard
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/uploadpic">
                  Upload Image
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/uploadfile">
                  Upload File
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link to="/viewcontact" className="tree-toggle nav-header">
                  View Contact
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" onClick={logout}>
                  Logout
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* end: Left Menu */}
        {/* start: content */}

        {/* end: content */}
        {/* start: right menu */}
      </div>{" "}
      <br />
      <div id="content">
        {" "}
        <br />
        <br />
        <div className="col-md-12" style={{ width: "100%" }}>
          <div>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Index No.</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(contactfirebase).map((all, index) => {
                  return (
                    <>
                      <tr>
                        <td>
                          <span style={{ width: "10%" }}>{index + 1}</span>
                        </td>
                        <span style={{ width: "10%" }}>
                          <td>{contactfirebase[all].name}</td>
                        </span>
                        <td>
                          <span style={{ width: "10%" }}>
                            {contactfirebase[all].email}
                          </span>
                        </td>
                        <td>
                          <span style={{ width: "10%" }}>
                            {contactfirebase[all].phone}
                          </span>
                        </td>
                        <td>
                          <span style={{ width: "100px" }}>
                            {contactfirebase[all].complain}
                          </span>
                        </td>

                        <td>
                          <button
                            className=" btn btn-info py-2"
                            onClick={() => del(all)}
                          >
                            Delete
                          </button>
                          <a href={contactfirebase[all].img} target={"_blank"}>
                            <button className=" btn btn-success">view</button>
                          </a>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Viewcontact;
